__turbopack_context__.v({
  "tesimonial__background": "Testemonial-module-scss-module__MWOaEW__tesimonial__background",
  "testemonial__image": "Testemonial-module-scss-module__MWOaEW__testemonial__image",
  "testemonial__quote": "Testemonial-module-scss-module__MWOaEW__testemonial__quote",
  "testimonial": "Testemonial-module-scss-module__MWOaEW__testimonial",
  "testimonial__arrow": "Testemonial-module-scss-module__MWOaEW__testimonial__arrow",
  "testimonial__arrow__backward": "Testemonial-module-scss-module__MWOaEW__testimonial__arrow__backward",
  "testimonial__arrow__forward": "Testemonial-module-scss-module__MWOaEW__testimonial__arrow__forward",
  "testimonial__arrow__hidden": "Testemonial-module-scss-module__MWOaEW__testimonial__arrow__hidden",
  "testimonial__bio": "Testemonial-module-scss-module__MWOaEW__testimonial__bio",
  "testimonial__dot": "Testemonial-module-scss-module__MWOaEW__testimonial__dot",
  "testimonial__dot__active": "Testemonial-module-scss-module__MWOaEW__testimonial__dot__active",
  "testimonial__dots": "Testemonial-module-scss-module__MWOaEW__testimonial__dots",
  "testimonialtrack": "Testemonial-module-scss-module__MWOaEW__testimonialtrack",
  "testimonialtrackinner": "Testemonial-module-scss-module__MWOaEW__testimonialtrackinner",
  "wrapper": "Testemonial-module-scss-module__MWOaEW__wrapper",
});
